import React from "react";
import { object, bool, string } from "prop-types";

import StoryMetaData from "../../molecules/StoryMetaData";

import "./sectionHolder.m.css";

const SectionHolder = ({ isMetaDataShown = true, story = {} }) => {
  return isMetaDataShown ? <div styleName="time">{<StoryMetaData story={story} />}</div> : null;
};

SectionHolder.propTypes = {
  isMetaDataShown: bool,
  story: object,
  pageType: string,
};

export default SectionHolder;
